import React from 'react';
import MuiTableCell, { TableCellProps } from '@mui/material/TableCell';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface IProps extends TableCellProps {
  noBottomBorder?: boolean;
  fullWidth?: boolean;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      stickyHeader: {
        backgroundColor: theme.palette.common.white,
      },
      borderless: {
        borderBottom: 'none',
      },
      fullWidth: {
        width: '100%',
      },
    } as const)
);

const EDTableCell = React.forwardRef((props: IProps, ref) => {
  const { noBottomBorder, fullWidth: fullWidthProp, ...rest } = props;
  const {
    cx,
    classes: { borderless, fullWidth, ...muiClasses },
  } = useStyles();
  return (
    <MuiTableCell
      {...rest}
      ref={ref}
      classes={{
        ...muiClasses,
        root: cx({
          [borderless]: noBottomBorder,
        }),
        body: cx({
          [fullWidth]: fullWidthProp,
        }),
      }}
    />
  );
});

export default EDTableCell;
